import LoginImage from "../assets/loginBack.svg";
import halloweenBg from "../assets/halloween/loginBg.svg";
import {HolidayEnum} from "../enums/holidayEnum";
export const Base = {
    name: HolidayEnum.base,
    colors: {
        text: "#51525C",
        buttonSpecialBg: "#52A5E5",
        loginFormBg: "#18181B",
    },
    images:{
        backgroundImg: LoginImage
    },
    fonts: {
        loginLabelFontSize:"14px",
        buttonFontSize: "14px",
        base: "'SF Pro Display', sans-serif",
        festive: "'SF Pro Display', sans-serif",
    },
};
export const Halloween = {
    name: HolidayEnum.halloween,
    colors: {
        text: "#FCFCFC",
        buttonSpecialBg: "#8361DA",
        loginFormBg: "#111114",
    },
    images:{
        backgroundImg: halloweenBg
    },
    fonts: {
        loginLabelFontSize:"20px",
        buttonFontSize: "20px",
        base: "'SF Pro Display', sans-serif",
        festive: "Purple Purse",
    },
};